import { Component, Input } from "@angular/core";
import { LoadingService } from "@main-services/loading.service";

@Component({
	selector: "loading-screen",
	templateUrl: "./loading-screen.component.html",
	styleUrls: ["./loading-screen.component.scss"],
	standalone: false
})
export class LoadingScreenComponent {
	@Input()
	public visibleByCondition: boolean = false;

	public constructor(public loadingService: LoadingService) {}
}
